export const cases = () => {
    const sections = document.querySelectorAll('.cases');

    sections?.forEach(section => {
        const points = section.querySelectorAll('.cases__item-point');
        const images = section.querySelectorAll('.cases__item-image');
        const intervalTime = 5000;
        const slideLength = images.length;
        let counter = 0;
        let interval;
        let remainingTime = intervalTime;
        let lastSlideChangeTime;
        let isSliderActive = false;
        let firstTimeAnimation = true;

        function slideChange() {
            counter = (counter + 1) % slideLength;
            console.log(counter);
            images.forEach(item => {
                item.classList.remove('active');
            });
            images[counter].classList.add('active');
            points.forEach(item => {
                item.classList.remove('active');
                item.querySelector('.cases__item-point-line-runner').classList.remove('running')
                item.querySelector('.cases__item-point-line-runner').classList.remove('paused')
                item.querySelector('.cases__item-point-line-runner').style.animation = 'none';
                void item.querySelector('.cases__item-point-line-runner').offsetWidth;
                item.querySelector('.cases__item-point-line-runner').style.animation = '';
            });
            points[counter].classList.add('active');
            lastSlideChangeTime = Date.now();
            remainingTime = intervalTime;
            startInterval();
        }

        function startInterval() {
            clearInterval(interval);
            interval = setInterval(slideChange, remainingTime);
        }

        function startSlider() {
            if (!isSliderActive) {
                if (window.matchMedia("(min-width:1024px)").matches) {
                    lastSlideChangeTime = Date.now();
                    points[0].classList.add('active');
                    images[0].classList.add('active');
                    startInterval();
                    isSliderActive = true;

                    points.forEach((tab, index) => {
                        tab.addEventListener('click', (item) => {
                            counter = index;

                            if (!item.currentTarget.classList.contains('active')) {
                                clearInterval(interval);
                                remainingTime = intervalTime;
                                points.forEach((item) => {
                                    item.classList.remove('active');
                                    item.querySelector('.cases__item-point-line-runner').style.animation = 'none';
                                    void item.querySelector('.cases__item-point-line-runner').offsetWidth;
                                    item.querySelector('.cases__item-point-line-runner').style.animation = '';
                                });

                                tab.classList.add('active');

                                images.forEach((item) => {
                                    item.classList.remove('active');
                                });

                                images[index].classList.add('active');
                                lastSlideChangeTime = Date.now();
                                remainingTime = intervalTime;
                                startInterval();
                            }
                        });

                        tab.addEventListener('mouseover', ()=> {
                            pauseSlider(index)
                        });
                        tab.addEventListener('mouseout', playSlider);
                    });
                } else {
                    clearInterval(interval);
                }
                firstTimeAnimation = false
            }
        }

        function stopSlider() {
            if (isSliderActive) {
                clearInterval(interval);
                isSliderActive = false;
                points.forEach(item => {
                    item.classList.remove('active');
                    item.querySelector('.cases__item-point-line-runner').style.animation = 'none';
                    void item.querySelector('.cases__item-point-line-runner').offsetWidth;
                    item.querySelector('.cases__item-point-line-runner').style.animation = '';
                });
            }
        }

        function pauseSlider(slideIndex) {
            if (isSliderActive) {
                if (typeof slideIndex === "number") {
                    if (slideIndex === counter) {
                        points.forEach(item => {
                            item.querySelector('.cases__item-point-line-runner').classList.remove('running')
                        })
                        points[counter].querySelector('.cases__item-point-line-runner').classList.add('paused')
                        clearInterval(interval);
                        remainingTime -= Date.now() - lastSlideChangeTime;
                        isSliderActive = false;
                    }
                } else {
                    points.forEach(item => {
                        item.querySelector('.cases__item-point-line-runner').classList.remove('running')
                    })
                    points[counter].querySelector('.cases__item-point-line-runner').classList.add('paused')
                    clearInterval(interval);
                    remainingTime -= Date.now() - lastSlideChangeTime;
                    isSliderActive = false;
                }
            }
        }

        function playSlider() {
            console.log(remainingTime)
            console.log(isSliderActive)
            if (!isSliderActive) {
                console.log('play')
                points.forEach(item => {
                    item.querySelector('.cases__item-point-line-runner').classList.remove('paused')
                })
                points[counter].querySelector('.cases__item-point-line-runner').classList.add('running')
                lastSlideChangeTime = Date.now();
                startInterval();
                isSliderActive = true;
            }
        }

        function checkSliderStatus() {
            const sectionTop = section.getBoundingClientRect().top + window.scrollY;
            const sectionBottom = sectionTop + section.scrollHeight;
            const viewTop = window.scrollY;
            const viewBottom = viewTop + window.innerHeight;

            if (viewBottom > sectionTop && viewTop < sectionBottom) {
                if (firstTimeAnimation) {
                    startSlider();
                } else {
                    playSlider();
                }
            } else {
                pauseSlider();
            }
        }

        function throttle(func, limit) {
            let inThrottle;
            return function() {
                if (!inThrottle) {
                    func.apply(this, arguments);
                    inThrottle = true;
                    setTimeout(() => inThrottle = false, limit);
                }
            }
        }

        const throttledCheckSliderStatus = throttle(checkSliderStatus, 200);

        window.addEventListener('scroll', throttledCheckSliderStatus);
        window.addEventListener('resize', throttledCheckSliderStatus);

        checkSliderStatus(); // Initial check
    });
};
